import { useMutation } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { updateDynamicLink } from 'src/services/napi/dynamicLinks/updateDynamicLink';
import { DynamicLink } from 'src/services/napi/dynamicLinks/interfaces/dynamicLink.interface';
import {
  UpdateDynamicLinkMutationFnParams,
  UseUpdateDynamicLinkMutationParams
} from './interfaces/useUpdateDynamicLinkMutation.interface';

const updateDynamicLinkMutationFn = async ({
  dynamicLinkId,
  requestBody
}: UpdateDynamicLinkMutationFnParams): Promise<DynamicLink | undefined> => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);
  const { _id: projectId } = currentProject ?? {};

  if (!projectId) return;

  const response = await updateDynamicLink({ dynamicLinkId, projectId, requestBody });
  return response?.dynamicLinkDetails;
};

export const useUpdateDynamicLinkMutation = ({
  onError,
  onSuccess
}: UseUpdateDynamicLinkMutationParams) => {
  const { notify } = useNotification();

  return useMutation({
    mutationFn: (data: UpdateDynamicLinkMutationFnParams) => updateDynamicLinkMutationFn(data),
    onError: () => {
      notify({ message: 'Error Updating Dynamic Link... Try again later', severity: 'error' });
      onError?.();
    },
    onSuccess: () => {
      notify({ message: 'Dynamic Link Updated Successfully' });
      onSuccess?.();
    }
  });
};
